import WGS84Service from '@/services/wgs84ProjectionService';

const dmsCoordinatesRegExp =
  // ^\s*         any amount of leading whitespace
  // (\d+)        capture the integer of degrees
  // °            degree symbol
  // \s*          any amount of whitespace
  // (\d+)        capture the integer of minutes
  // ['′]         single quote or prime
  // \s*          any amount of whitespace
  // (\d+\.?\d*)  capture the decimal of seconds
  // (?:"|″|'')   double quote, double prime or two single quotes
  // \s*          any amount of whitespace
  // ([NESW])     capture N, S, E or W of the cardinal direction
  // \s*$         any amount of trailing whitespace
  /^\s*(\d+)°\s*(\d+)['′]\s*(\d*\.?\d*)(?:"|″|'')\s*([NESW])\s*$/;

const signedFloatNumberRegExp =
  // ^\s*         any amount of leading whitespace
  // [-+]?        optional sign
  // \d+          one or more digits
  // \.?          optional decimal point
  // \d*          zero or more digits
  // \s*$         any amount of trailing whitespace
  /^\s*[+-]?\d+\.?\d*\s*$/;

export default {
  methods: {
    areCoordinatesValid(coordinates) {
      if (
        (coordinates || []).length >= 2 &&
        !String(coordinates[0]).includes(',') &&
        !String(coordinates[1]).includes(',')
      ) {
        const coordinate = {
          lat: parseFloat(coordinates[1]),
          lon: parseFloat(coordinates[0]),
        };
        return WGS84Service.isValidWgs84(coordinate);
      }
      return false;
    },
    ruleValidateCoordinates(value) {
      return [
        value === undefined ||
          value === null ||
          String(value).trim() === '' ||
          dmsCoordinatesRegExp.test(value) ||
          (signedFloatNumberRegExp.test(value) && Math.abs(parseFloat(value)) < 360) ||
          this.$i18n_t('Common.errorCoordinateNotValid'),
      ];
    },
    parseCoordinate(input) {
      let parsedDms;
      const parts = String(input).toUpperCase().match(dmsCoordinatesRegExp);

      if (parts) {
        const degrees = parseFloat(parts[1]);
        const minutes = parseFloat(parts[2]);
        const seconds = parseFloat(parts[3]);
        const direction = parts[4];
        parsedDms = degrees + minutes / 60 + seconds / 3600;

        if (direction === 'S' || direction === 'W') {
          parsedDms = -parsedDms;
        }
      }

      const result = Number(parsedDms || input).toFixed(10);
      return parseFloat(result) || null;
    },
    handleParsingCoordinates(coordinates) {
      coordinates[0] = this.parseCoordinate(coordinates[0]);
      coordinates[1] = this.parseCoordinate(coordinates[1]);
    },
    formatLonLat(coordinates, index) {
      coordinates[index] = String(coordinates[index]).includes(',')
        ? String(coordinates[index]).replace(',', '.')
        : coordinates[index];
    },
  },
};
